// extracted by mini-css-extract-plugin
export default {"list-tags-container":"ListTags_list-tags-container__XWj2P","hover":"ListTags_hover__rJKCe"};